'use client';
/** @jsxImportSource @emotion/react */

import type { PaginationProps as MuiPaginationProps } from '@mui/material/Pagination';

import MuiPagination from '@mui/material/Pagination';

type ExcludedMuiProps = 'disabled' | 'hideNextButton' | 'hidePrevButton';

interface PaginationProps extends Omit<MuiPaginationProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { PaginationProps };
export const Pagination: React.FC<PaginationProps> = MuiPagination;

Pagination.displayName = 'Pagination';
